module.exports = __webpack_public_path__ + "static/8Foto-Header-ACO-Parkdeckrinne-Deckline-03f3cbcb00935e1c2a0e5e3a0d760dda.jpg";